/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Capture_SnippetInputs */

const en_funnel_sq_capture_snippet = /** @type {(inputs: Funnel_Sq_Capture_SnippetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Loss aversion shapes how we weigh risk…"`)
};

const es_funnel_sq_capture_snippet = /** @type {(inputs: Funnel_Sq_Capture_SnippetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`«La aversión a la pérdida moldea cómo evaluamos el riesgo…»`)
};

/**
* | output |
* | --- |
* | "\"Loss aversion shapes how we weigh risk…\"" |
*
* @param {Funnel_Sq_Capture_SnippetInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_capture_snippet = /** @type {((inputs?: Funnel_Sq_Capture_SnippetInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Capture_SnippetInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_capture_snippet(inputs)
	return en_funnel_sq_capture_snippet(inputs)
});